import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useRemoveExpirationWarning = () => {
  return useMutation((dto) =>
    http.put(HTTP_ENDPOINTS.removeExpirationWarning(), dto),
  );
};
